import React from "react";
import { 
    Box, 
    Flex, 
    Text, 
    Heading, 
    VStack 
} from "@chakra-ui/react";
import CustomCard from "../ui/card";
import { formatDateToReadableShortString } from "../../utilities/others";

type TimelineProps = {
    children?: React.ReactNode;
    isLastChild: boolean;
    circleColour: string
}

function TimelineItem({ children, ...item }: TimelineProps) {
    return (
        <Flex minH='70px' position={'relative'}>
            <Flex direction='column' flex='0 1 0%' alignItems='center'>
                <span className="o-timeline-circle" style={{ backgroundColor: item.circleColour }}></span>
               {!item.isLastChild?  <span className="o-timeline-line"></span> : null}
            </Flex>
            <Box flex='1 1 0%' lineHeight={'1.5'} padding='6px 16px' textAlign='left' fontSize='1rem'>
                {children}
            </Box>
        </Flex>
    )
}

export default function OverviewTimeline() {
    const timelines = [
        {id: '1', title: 'Bham company signed up', createdAt: formatDateToReadableShortString('2021-06-28T07:48:34')},
        {id: '2', title: 'Incoming $100 from signup', createdAt: formatDateToReadableShortString('2021-06-28T07:48:34')},
        {id: '3', title: '1983, orders, $4220', createdAt: formatDateToReadableShortString('2021-06-28T07:48:34')},
        {id: '4', title: '1983, orders, $4220', createdAt: formatDateToReadableShortString('2021-06-28T07:48:34')},
    ]

    return (
        <CustomCard className='overview-col-35' children={(
            <>
                <Heading as='h4' size='md' marginBottom={'6'}>
                    Timeline
                </Heading>
                
                <VStack spacing={2} padding='6px 0 0' alignItems={'stretch'}>
                    {timelines.map((t, index) => (
                        <TimelineItem 
                            key={t.id}
                            isLastChild={timelines.length - 1 === index}
                            circleColour={index === 1 || index === 3 ? 'blue' : 'lightcoral'}
                            children={(
                                <>
                                    <Text fontSize='sm' fontWeight={'semibold'}>{t.title}</Text>
                                    <Text fontSize='sm' color={'gray.500'}>{t.createdAt}</Text>
                                </>
                            )}
                            {...t}
                        />
                    ))}
                </VStack>
            </>
        )} />
    )
}